import { Directive, ElementRef, inject, OnInit } from '@angular/core';

@Directive({ selector: '[bnWebUiAutofocus]' })
export class AutofocusDirective implements OnInit {
  private elementRef = inject(ElementRef);

  ngOnInit(): void {
    setTimeout(() => {
      this.elementRef.nativeElement.querySelector('input, textarea, select').focus();
    }, 0);
  }
}
